import React from 'react';
import resourcesIcons from '../images/resources-icons';
import { parseDomainFromUrl } from '../lib/utils';

const {
  pdf: Pdf,
  otherEN: OtherEN,
  otherES: OtherES,
  otherPT: OtherPT,
  app: App,
  article: Article,
  book: Book,
  course: Course,
  doc: Doc,
  graphic: Graphic,
  podcast: Podcast,
  slideshow: Slideshow,
  video: Video,
  website: Website,
  xls: Xls,
} = resourcesIcons;

interface IResourceIcon {
  [key: string]: React.Component<any> | any,
}

export const RESOURCE_ICONS: IResourceIcon = {
  pdf: <Pdf />,
  other: { en: <OtherEN />, es: <OtherES />, pt: <OtherPT /> },
  app: <App />,
  article: <Article />,
  book: <Book />,
  course: <Course />,
  doc: <Doc />,
  graphic: <Graphic />,
  image: <Graphic />,
  podcast: <Podcast />,
  slideshow: <Slideshow />,
  video: <Video />,
  website: <Website />,
  xls: <Xls />,
  link: <Website />,
  application: <Slideshow />,
  audio: <Podcast />,
};

interface IArrayType {
  [key: string]: string[],
}

export const EXTENSION_TYPE: IArrayType = {
  pdf: ['pdf'],
  doc: ['doc', 'docx', 'pages', 'rtf'],
  graphic: ['png', 'jpg', 'jpeg', 'gif', 'heic', 'svg', 'tiff'],
  podcast: ['mp3', 'm4a', 'acc', 'wav', 'wma', 'aac', 'ra', 'ogg'],
  slideshow: ['ppt', 'pptx', 'keynote', 'key'],
  video: ['mp4', 'mpeg', 'mpeg-4', 'mov', 'wmv', 'avi', 'mkv', 'flv'],
  xls: ['xls', 'xlsx', 'csv', 'numbers', 'tsv'],
};

export const getFileTypeByExtension = (extension: string) => Object.keys(EXTENSION_TYPE).find(key => EXTENSION_TYPE[key].includes(extension.toLowerCase())) || 'other';

export const getTabValue = (id: number | null) => {
  let tabValue = '';
  switch (id) {
    case 1: tabValue = 'tabTeachers';
      break;
    case 2: tabValue = 'tabParents';
      break;
    case 3: tabValue = 'tabStudents';
      break;
    default: tabValue = '';
      break;
  }
  return tabValue;
};

export const SUPPORTED_VIDEO_DOMAINS: IArrayType = {
  youtube: ['youtube.com', 'youtu.be'],
  vimeo: ['vimeo.com'],
};

export const supportedVideoDomains = Object.values(SUPPORTED_VIDEO_DOMAINS).flat();

export const isVideoUrlSupported = (url: string) =>
  supportedVideoDomains.some(domain => parseDomainFromUrl(url) === domain);

export const tabIds = {
  Teachers: 1,
  Parents: 2,
  Students: 3,
};

export const tabNameById = {
  [tabIds.Teachers]: 'Teachers',
  [tabIds.Parents]: 'Parents',
  [tabIds.Students]: 'Students',
};
